import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{ $whiteColor?: boolean }>`

/*
  1. Use a more-intuitive box-sizing model.
*/
*, *::before, *::after {
  box-sizing: border-box;
}
/*
  2. Remove default margin
*/
* {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/
body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font-family: 'Poppins', sans-serif;
    color: #171717;
  /* overflow-x: hidden; */
}
/*
  5. Improve media defaults
*/
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
input, button, textarea, select {
  font: inherit;
}
/*
  7. Avoid text overflows
*/
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}
/*
  8. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
}

.containerIdosellPages{
    width: 1200px;
    margin: 0 auto;
}
.table__minus, .table__plus {
  display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
}

.table__plus {
    color: #171717;
    font-size: 35px;
}

.table__minus {
    opacity: 0.5;
    color: #c8c8c8;
    font-size: 35px;
}
.d-block {
  display: block;
}
.--green {
  color: rgb(26, 172, 122);
}

@media (max-width: 768px) {
  .containerIdosellPages {
    max-width:95%;
  }
}

@media (min-width: 769px) {
  .containerIdosellPages {
    max-width:95%;
  }
}

@media (min-width: 1250px) {
  .containerIdosellPages {
    max-width:100%;
  }
}

`;
